<div class="input-container">
    <nz-input-group [nzPrefix]="prefixTemplateTag" class="input-box">
    </nz-input-group>
    <ng-template #prefixTemplateTag>
        <nz-tag
            *ngFor="let item of tags; let i = index"
            [nzColor]="color"
            class="tag-item"
        >
            <div class="tag-name">{{ item }}</div>
            <div class="delete-icon">
                <span
                    nz-icon
                    nzType="close-circle"
                    nzTheme="outline"
                    (click)="onClose(i)"
                    class="close-icon"
                ></span>
            </div>
        </nz-tag>
        <input
            type="text"
            nz-input
            class="input"
            [nzBorderless]="true"
            [(ngModel)]="keyword"
            [placeholder]="tags.length === 0 ? placeholder : ''"
            (keydown)="enterSearch($event)"
            (ngModelChange)="changeKeyword()"
        />
    </ng-template>
</div>
